import { SingleStepCircle } from './style/SingleStepCircle';
import { SingleStepWrapper } from './style/SingleStepWrapper';

type SingleStepProps = {
  isCompleted: boolean;
  isActive: boolean;
  step: number;
};

const SingleStep = (props: SingleStepProps) => {
  const { isCompleted, isActive, step } = props;

  return (
    <SingleStepWrapper>
      <SingleStepCircle isCompleted={isCompleted} isActive={isActive}>
        {step}
      </SingleStepCircle>
    </SingleStepWrapper>
  );
};

export default SingleStep;
